import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO = ({ title, description, keywords, canonical }) => {
  const location = useLocation();
  const baseTitle = "Cart Studio";
  const fullTitle = title ? `${title} | ${baseTitle}` : `${baseTitle} | Custom Tricycle Carts & E-Cart Manufacturer`;

  useEffect(() => {
    // Update Document Title
    document.title = fullTitle;

    // Update Meta Description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description || "India's leading manufacturer of high-quality Tricycle Carts, E-Carts, and specialized Rickshaws for B2B solutions.");
    }

    // Update Meta Keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', keywords || "cart studio, tricycle carts, e-carts manufacturer, ice cream carts india, custom street food carts");
    }

    // Update Web Canonical URL
    let linkCanonical = document.querySelector('link[rel="canonical"]');
    if (linkCanonical) {
      linkCanonical.setAttribute('href', canonical || `https://www.cartstudio.in${location.pathname}`);
    }

    // OG Title
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', fullTitle);

    // OG Description
    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) ogDescription.setAttribute('content', description || "Premium manufacturer of custom Tricycle Carts and E-Carts.");

  }, [fullTitle, description, keywords, canonical, location.pathname]);

  return null;
};

export default SEO;
